import { TRPCClientError } from '@trpc/client'
import { type DefaultErrorShape } from '@trpc/server'
import { UiErrorDetail } from '../components/ErrorModal/ErrorModal'
import { NETWORK_ERROR_DEDUPE_KEY } from './networkErrorConstants'

const isAbortError = (cause: unknown): boolean => {
  if (!cause || typeof cause !== 'object') return false
  const maybeError = cause as { name?: string }
  return maybeError.name === 'AbortError'
}

export const toTrpcUiError = (
  error: TRPCClientError<DefaultErrorShape>,
  defaultVerb: string,
): UiErrorDetail | undefined => {
  const statusCode = error.data?.httpStatus
  const action = error.data?.path ?? 'request'

  if (isAbortError(error.cause)) {
    return undefined
  }

  if (statusCode === undefined) {
    return {
      title: 'Network error',
      content: 'Unable to reach the server. Check your connection and try again.',
      dedupeKey: NETWORK_ERROR_DEDUPE_KEY,
    }
  }

  if (statusCode === 400)
    return {
      content: error.message,
    }
  if (statusCode === 401)
    return {
      title: 'Unauthorized',
      content: 'You are not authorized',
    }
  if (statusCode === 403)
    return {
      title: 'Forbidden',
      content: `You are not allowed to perform '${action}'`,
    }
  if (statusCode === 404)
    return {
      title: 'Not Found',
      content: 'The requested resource was not found',
    }
  if (statusCode === 500) return { content: error.message }
  return {
    title: `Failed to ${defaultVerb} ${action}`,
    content: error.message,
  }
}
